// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-pill_a65692ce {
  margin: 0;
  padding: 0;
  border: 0;
}
.label-pill_a65692ce {
  display: flex;
  align-items: center;
  height: 1.167rem;
  background-color: #dce1e5;
  border-radius: 8.334rem;
  color: #11304d;
  padding: 0 0.667rem;
  font-size: 0.834rem;
  line-height: 1.25;
}
.label-pill__prefix_a65692ce {
  padding-right: 0.334rem;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.label-pill__button_a65692ce {
  padding-left: 0.5rem;
  cursor: pointer;
  display: flex;
}
.label-pill-medium_a65692ce {
  height: auto;
  text-align: center;
  border-radius: 0.667rem;
  padding: 0.334rem 0.667rem;
  line-height: 1rem;
  word-break: break-word;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label-pill": `label-pill_a65692ce`,
	"label-pill__prefix": `label-pill__prefix_a65692ce`,
	"label-pill__button": `label-pill__button_a65692ce`,
	"label-pill-medium": `label-pill-medium_a65692ce`
};
export default ___CSS_LOADER_EXPORT___;
